import React from 'react';
import { Button } from '@progress/kendo-react-buttons';
import './AddEditReferralsRequest.Header.scss';
import { PrimaryButton, SecondaryButton } from 'v3/Components/Shared/Buttons';
import { StatusPill } from 'v3/Components/Shared/StatusPill';
import bodySystem from 'Assets/Icons/body_system_header.svg';
import cardiology from 'Assets/Icons/cardiology_header.svg';
import stethoscope from 'Assets/Icons/stethoscope_header.svg';
import conditions from 'Assets/Icons/conditions_header.svg';
import heapSnapdshotLarge from 'Assets/Icons/heap_snapshot_large_header.svg';
import badge from 'Assets/Icons/badge_header.svg';
import pharmacy from 'Assets/Icons/local_pharmacy_header.svg';
import calendar from 'Assets/Icons/calendar_today_header.svg';

export type AddEditReferralsRequestHeaderProps = {
  onDiscard: () => void;
  onSaveDraft: () => void;
  savingDraft?: boolean;
  lob?: string;
  status?: string;
  referralDate?: string;
  dueDate?: string;
  isDraft?: boolean;
  isUploadingFiles?: boolean;
};

const AddEditReferralsRequestHeader: React.FC<
  AddEditReferralsRequestHeaderProps
> = ({
  onDiscard,
  onSaveDraft,
  lob,
  status,
  referralDate,
  dueDate,
  savingDraft,
  isDraft,
  isUploadingFiles,
}) => {
  const iconMap: Record<string, string> = {
    IME: conditions,
    Pharmacy: pharmacy,
    Disability: bodySystem,
    'Health Review': cardiology,
    'Impairment Rating Review': heapSnapdshotLarge,
    'Workers Comp - Peer Review': badge,
    "Worker's Comp": badge,
  };

  return (
    <div className="referral-header">
      <div className="header-title">
        <div className="display-flex align-items-center">
          <h1>Referral Request</h1>
          {status ? <StatusPill status={status} /> : ''}
        </div>
        <div className="header-lob">
          <div>
            <span className="lob-label">Line of Business</span>
            <span className="lob-value">
              {iconMap[lob as string] && (
                <img
                  src={iconMap[lob as string]}
                  alt=""
                  className="dropdown-option-icon"
                  style={{ marginRight: 6, width: 18, height: 18 }}
                />
              )}
              {` ${lob}`}
            </span>
          </div>
          <div>
            <span className="lob-label">Referral Date</span>
            <span className="lob-value">
              <img
                src={calendar}
                alt=""
                className="dropdown-option-icon"
                style={{ marginRight: 6, width: 18, height: 18 }}
              />
              {` ${referralDate}`}
            </span>
          </div>
          {dueDate && (
            <div>
              <span className="lob-label">Due Date</span>
              <span className="lob-value">
                <img
                  src={calendar}
                  alt=""
                  className="dropdown-option-icon"
                  style={{ marginRight: 6, width: 18, height: 18 }}
                />
                {` ${dueDate}`}
              </span>
            </div>
          )}
        </div>
      </div>
      {isDraft && (
        <div className="header-buttons">
          <SecondaryButton
            title="Discard Draft"
            className="centered no-border"
            onClick={onDiscard}
          />
          <SecondaryButton
            title="Save Draft & Finish Later"
            onClick={onSaveDraft}
            disabled={savingDraft || isUploadingFiles}
          />
        </div>
      )}
    </div>
  );
};

export default AddEditReferralsRequestHeader;
